import { axiosInstance } from '../common/api';

export const trackerRunningService = (data) => {
  const url = `/tracker`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const fetchTaskList = () => {
  const url = `/tracker`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const addManualTimeEntry = (data) => {
  const url = `/tracker/addTime`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const fetchRunningTask = (id) => {
  const url = `/tracker/runningTask/${id || ""}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const trackerUpdate = (id, data) => {
  const url = `/tracker/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const trackerDelete = (id) => {
  const url = `/tracker/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const trackerUpdateRunning = (data) => {
  const url = `/tracker/update`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const fetchAllRunnedTask = (taskId)=>{
  const url = `/tracker/running-timeTracker/${taskId}`
  return new Promise((resolve,reject)=>{
    axiosInstance
      .get(url)
      .then((response)=>resolve(response))
      .catch((err)=>reject(err))
  })
}